export default "__VITE_ASSET__BddpIzXU__"